import { environment } from "../../../environments/environment";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable({ providedIn: 'root' })
export class AssemblyService {

  constructor(private http: HttpClient) {

  }

  //async getAssemblyVersion() {
  //  return await this.http.get(`${environment.apiUrl}/Assembly`).toPromise();
  //}
}
